var _defs, _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 955.45 121.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #06038d;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 696.34,
    y: 6.75,
    width: 23.76,
    height: 108.79
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "109.91 0 141.49 34.81 55.8 34.79 24.71 0 109.91 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.6 80.8 49.19 80.89 89.49 121.26 40.15 120.94 0 80.97 .08 80.97 .08 80.89 0 80.89 16.5 46.28 77.57 46.37 101.41 80.8 99.6 80.8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.37,6.75h75.48v20.75h-51.88v29.63h37.66v20.42h-37.66v37.99h-23.6V6.75h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.35,94.45h-35.32l-5.19,21.09h-24.27l28.62-108.79h37.33l28.12,108.79h-24.1l-5.19-21.09h0ZM280.88,74.87h25.78l-11.72-48.03h-2.34l-11.72,48.03Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M447.93,72.86v22.26c0,10.71-5.19,20.42-20.08,20.42h-43.01c-13.05,0-20.59-7.03-20.59-20.75V26.84c0-14.73,7.03-20.08,18.75-20.08h45.86c14.06,0,19.08,7.03,19.08,21.59v15.06h-23.43v-15.56h-36.99v66.78h36.99v-21.76h23.43-.01Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M502.5,27.5h-30.8V6.75h85.19v20.75h-30.63v88.04h-23.76V27.5h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M582.35,115.54V6.75h67.11c11.38,0,15.9,6.53,15.9,19.25v39c0,10.54-3.52,16.07-12.05,17.24l12.05,33.31h-23.77l-11.21-32.47h-24.44v32.47h-23.6.01ZM642.1,62.98V27.83h-36.15v35.15h36.15Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M752.41,115.54V6.75h23.6v44.52h4.02l31.47-44.52h27.61l-37.15,52.39v1.5l39.33,54.9h-28.45l-32.8-45.52h-4.02v45.52h-23.61Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M926.15,94.45h-35.32l-5.18,21.09h-24.27l28.62-108.79h37.33l28.12,108.79h-24.1l-5.19-21.09h-.01ZM895.68,74.87h25.78l-11.71-48.03h-2.35l-11.72,48.03h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.efc12e31e88f6da40f2113b67f67991b.svg";
export { ForwardRef as ReactComponent };